import styled from "styled-components";

export const CardWrapper = styled.div<{ destacado?: boolean }>`
    width: 100%;
    position: relative;
    border: 1px solid ${({ theme }) => theme.colors.interfaceGray200 || '#E5E7EB'};
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.interfacePure0 || '#FFFFFF'};
    overflow: hidden;
    margin-bottom: 16px;
    border: ${props => props.destacado ? '2px solid #E52940' : `1px solid ${props.theme.colors.interfaceGray200 || '#E5E7EB'}`};
    box-shadow: ${props => props.destacado ? '0 0 0 3px rgba(229, 41, 64, 0.1)' : 'none'};
`;

export const Container = styled.div<{ isResposta?: boolean; destacado?: boolean; nivel?: number }>`
    width: ${props => props.isResposta ? `calc(100% - ${48 * (props.nivel || 1)}px)` : '100%'};
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    padding: 16px;
    transition: background-color 0.2s ease;
    position: relative;
    cursor: default;
    border-top: ${props => props.isResposta ? `1px solid ${props.theme.colors.interfaceGray200 || '#E5E7EB'}` : 'none'};
    margin-left: ${props => props.isResposta ? `${48 * (props.nivel || 1)}px` : '0'};
    margin-right: 0;

    &:hover {
        background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};
    }

    @media (max-width: 640px) {
        flex-direction: column;
        gap: 8px;
        padding: 16px;
        margin-left: ${props => props.isResposta ? `${24 * (props.nivel || 1)}px` : '0'};
        width: ${props => props.isResposta ? `calc(100% - ${24 * (props.nivel || 1)}px)` : '100%'};
        align-items: flex-start;
    }

    .linha-principal {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
        margin: 0;
        padding: 0;

        @media (max-width: 640px) {
            align-items: flex-start;
        }
    }

    .avatar {
        flex-shrink: 0;
        
        .avatar-inner {
            width: ${props => props.isResposta ? '32px' : '40px'};
            height: ${props => props.isResposta ? '32px' : '40px'};
            border-radius: 50%;
            background-color: ${({ theme }) => theme.colors.primaryRed300 || '#ffbfc7'};
            color: var(--comment-avatar-ink);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 600;
            flex-shrink: 0;

            @media (max-width: 640px) {
                width: ${props => props.isResposta ? '28px' : '36px'};
                height: ${props => props.isResposta ? '28px' : '36px'};
                font-size: 13px;
            }
        }
    }

    .conteudo {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
        min-width: 0;
        position: relative;
        min-height: fit-content;

        .header {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            margin: 0;
            padding: 0;
            flex-wrap: nowrap;

            @media (max-width: 640px) {
                flex-wrap: wrap;
                gap: 6px;
            }

            .autor-info {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 8px;
                margin: 0;
                padding: 0;
                flex-wrap: wrap;

                .autor-nome {
                    font-size: 14px;
                    font-weight: 600;
                    color: ${({ theme }) => theme.colors.c000000};
                }

                .tipo-badge {
                    padding: 2px 6px;
                    border-radius: 10px;
                    font-size: 10px;
                    font-weight: 600;
                    text-transform: none;
                    background-color: ${(props: any) => props.theme.colors.cf3f4f6};
                    color: ${(props: any) => props.theme.colors.c374151};
                    border: 1px solid ${({ theme }) => theme.colors.interfaceGray200 || '#E5E7EB'};
                    white-space: nowrap;
                    line-height: 1.2;
                }

                .badge-desvinculado {
                    padding: 4px 8px;
                    border-radius: 6px;
                    font-size: 12px;
                    font-weight: 500;
                    text-transform: capitalize;
                    background-color: rgb(243, 244, 246);
                    color: rgb(107, 114, 128);
                    margin-left: 8px;
                    line-height: 1.2;
                }
            }

            .autor-container {
                display: flex;
                flex-direction: row;
                gap: 0;
                align-items: flex-start;
                justify-content: center;
                margin: 0;
                padding: 0;

                .destinatario-subtitulo {
                    font-size: 12px;
                    color: ${({ theme }) => theme.colors.interfaceText400 || '#5A646E'};
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-top: 2px;
                }
            }

            .timestamp {
                font-size: 12px;
                color: ${({ theme }) => theme.colors.interfaceGray400 || '#9CA3AF'};
                font-weight: 400;
                white-space: nowrap;
            }
        }

        .destinatario {
            font-size: 14px;
            color: ${({ theme }) => theme.colors.interfaceGray500 || '#6B7280'};
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 4px;
            margin-top: 4px;
            
            .destinatario-label {
                font-weight: 400;
            }
            
            .destinatario-nome {
                font-weight: 600;
            }
        }

        .texto {
            font-size: 14px;
            color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
            line-height: 1.5;
            word-break: break-word;
            white-space: pre-wrap;
        }

        .acoes-container {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            margin-top: 0px;
            margin-left: 0;
            padding-top: 0px;
            flex-wrap: nowrap;
        }

        .responder-container {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-top: 8px;
            margin-left: -4px;
            height: 28px;
            visibility: hidden;
            transition: visibility 0.2s ease;
            
            &.visible {
                visibility: visible;
            }
            
            .destinatario {
                font-size: 14px;
                color: ${({ theme }) => theme.colors.interfaceGray500 || '#6B7280'};
                display: flex;
                align-items: center;
                gap: 4px;
            }
        }
    }

    .conteudo.corpo-conteudo {
        width: calc(100% - 52px);
        margin-left: 52px;
        gap: 8px;
        box-sizing: border-box;
        min-width: 0;

        &.resposta {
            width: calc(100% - 44px);
            margin-left: 44px;
        }

        @media (max-width: 640px) {
            width: 100%;
            margin-left: 0;
        }
    }
`;

export const BotaoResponder = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
    background-color: transparent;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    outline: none;
    width: fit-content;

    &:hover,
    &:focus {
        background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const TextoDestinatario = styled.span`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceText400 || '#5A646E'};
    margin-left: 8px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const BadgeTipoDestinatario = styled.span`
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 600;
    text-transform: none;
    background-color: ${(props: any) => props.theme.colors.cf3f4f6};
    color: ${(props: any) => props.theme.colors.c374151};
    border: 1px solid ${({ theme }) => theme.colors.interfaceGray200 || '#E5E7EB'};
    white-space: nowrap;
    line-height: 1.2;
`;

export const AcaoButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    background-color: transparent;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: ${({ theme }) => theme.colors.interfaceGray500 || '#6F777E'};

    &:hover {
        background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};
    }

    &.delete {
        color: ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
        
        &:hover {
            background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};
        }
    }

    svg {
        width: 16px;
        height: 16px;
    }

    svg[width="19"] {
        width: 16px !important;
        height: 16px !important;
    }

    svg path {
        stroke: currentColor;
        fill: none;
    }
`;

export const TooltipContainer = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

export const Tooltip = styled.div`
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    background: ${({ theme }) => theme.colors?.interfaceGray700 || '#333'};
    color: ${({ theme }) => theme.colors?.interfacePure0 || '#fff'};
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 8px;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(0,0,0,0.18);
    z-index: 9999;
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease, visibility 0.2s ease;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-width: 6px;
        border-style: solid;
        border-color: ${({ theme }) => theme.colors?.interfaceGray700 || '#333'} transparent transparent transparent;
    }

    &.visible {
        opacity: 1;
        visibility: visible;
    }

    &.left {
        right: calc(100% + 8px);
        left: auto;
        transform: translateX(0);
        bottom: 50%;
        top: auto;
        margin-bottom: -6px;

        &::after {
            top: 50%;
            left: 100%;
            margin-top: -6px;
            margin-left: 0;
            border-color: transparent transparent transparent ${({ theme }) => theme.colors?.interfaceGray700 || '#333'};
        }
    }
`;

export const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MenuButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 6px;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};
        padding: 4px;
    }

    &:active {
        background-color: ${({ theme }) => theme.colors.interfacePure200 || '#CCCCCC'};
        padding: 4px;
    }

    &:focus {
        outline: 2px solid ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
        outline-offset: 2px;
    }
`;

export const MenuDropdown = styled.div`
    position: fixed;
    background: ${(props: any) => props.theme.colors.interfacePure0};
    border-radius: 8px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    min-width: 160px;
    z-index: 10000;
    padding: 8px 0;
    display: flex;
    flex-direction: column;
`;

export const MenuItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
    cursor: pointer;
    transition: background-color 0.2s ease;
    outline: none;

    &:hover,
    &:focus {
        background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};
    }

    &.delete {
        color: ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const TextareaEditavel = styled.textarea`
    width: 100%;
    min-height: 60px;
    max-height: 300px;
    padding: 8px 12px;
    font-size: 14px;
    font-family: inherit;
    color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
    border: 1px solid ${({ theme }) => theme.colors.interfaceGray300 || '#D1D5DB'};
    border-radius: 6px;
    resize: none;
    overflow-y: auto;
    line-height: 1.5;
    transition: all 0.2s ease;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
        box-shadow: 0 0 0 3px rgba(229, 41, 64, 0.1);
    }

    &::placeholder {
        color: ${({ theme }) => theme.colors.interfaceGray400 || '#9CA3AF'};
    }
`;

export const BotoesEdicao = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 8px;
    width: 100%;
    justify-content: flex-end;
    flex-wrap: nowrap;
    min-width: 0;
    box-sizing: border-box;
`;

export const BotaoSalvar = styled.button`
    padding: 8px 16px;
    min-height: 40px;
    font-size: 14px;
    font-weight: 500;
    color: ${(props: any) => props.theme.colors.pureWhite};
    background-color: ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    transform: scale(1);

    &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.colors.primaryRed500 || '#C91E37'};
        transform: scale(1.02);
    }

    &:active:not(:disabled) {
        transform: scale(0.98);
    }

    &:focus {
        outline: 2px solid ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
        outline-offset: 2px;
    }

    &:disabled {
        background: ${({theme}) => theme.colors.disabledBg};
        border-color: ${({theme}) => theme.colors.disabledBg};
        color: ${({theme}) => theme.colors.disabledText};
        cursor: not-allowed;
        opacity: 0.6;
    }

    &.delete {
        background-color: ${({ theme }) => theme.colors.primaryRed400 || '#E52940'};
        
        &:hover:not(:disabled) {
            background-color: ${({ theme }) => theme.colors.primaryRed500 || '#C91E37'};
        }
    }
`;

export const BotaoCancelar = styled.button`
    padding: 8px 16px;
    min-height: 40px;
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colors.interfaceGray300 || '#D1D5DB'};
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    transform: scale(1);

    &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.colors.interfaceGray100 || '#F3F4F6'};
        transform: scale(1.02);
    }

    &:active:not(:disabled) {
        transform: scale(0.98);
    }

    &:focus {
        outline: 2px solid ${({ theme }) => theme.colors.interfaceGray400 || '#9CA3AF'};
        outline-offset: 2px;
    }

    &:disabled {
        background: ${({theme}) => theme.colors.disabledBg};
        border-color: ${({theme}) => theme.colors.disabledBg};
        color: ${({theme}) => theme.colors.disabledText};
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const IndicadorEditado = styled.span`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.interfaceGray400 || '#9CA3AF'};
    font-style: italic;
    margin-top: -4px;
`;

export const OverlayConfirmacao = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    backdrop-filter: blur(2px);
`;

export const OverlayContent = styled.div`
    text-align: center;
    max-width: 400px;
    width: 90%;
    padding: 24px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.interfaceText900 || '#111827'};
        margin-bottom: 12px;
    }

    p {
        font-size: 14px;
        color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
        margin-bottom: 24px;
        line-height: 1.5;
    }

    .botoes {
        display: flex;
        gap: 12px;
        justify-content: center;
    }
`;

export const RespostasContainer = styled.div`
    padding: 0;
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    left: 0;
    right: 0;
`;

export const FormRespostaContainer = styled.div`
    display: flex;
    gap: 12px;
    padding: 12px 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.interfaceGray200 || '#E5E7EB'};
    background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F2F2F2'};

    .avatar-placeholder {
        width: 40px;
        height: 40px;
        flex-shrink: 0;
    }
    
    > div {
        flex: 1;
    }
`;

export const ModalContent = styled.div`
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.interfaceText900 || '#111827'};
        margin-bottom: 12px;
    }

    p {
        font-size: 14px;
        color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
        margin-bottom: 20px;
        line-height: 1.5;
    }

    .botoes {
        display: flex;
        gap: 12px;
        justify-content: center;
    }
`;
